import { COMPANY_EMPLOYEE } from "./types";

import ActionHelper from "../helpers/ActionHelper";

import moment, { isMoment } from "moment";

export const getHourRegistrationOfCompanyEmployee = (
  companyEmail,
  employeeEmail,
  beginDate,
  endDate,
) => {
  let params = [];

  if (isMoment(beginDate)) {
    beginDate.startOf("day");

    params.push(`beginDate=${beginDate.toISOString()}`);
  }

  if (isMoment(endDate)) {
    endDate.endOf("day");

    params.push(`endDate=${endDate.toISOString()}`);
  }

  return ActionHelper.requestServer(
    "GET",
    `/company/${companyEmail}/employee/${employeeEmail}/hour_registration?${params.join(
      "&",
    )}`,
  );
};

export const notifyErrorCompanyEmployeeAssignment =
  (companyEmail, employeeEmail, body) => (dispatch) => {
    return ActionHelper.requestServer(
      "POST",
      `/company/${companyEmail}/employee/${employeeEmail}/notify_error`,
      body,
      COMPANY_EMPLOYEE.COMPANY_EMPLOYEE_NOTIFY_ERROR_REQUEST,
      COMPANY_EMPLOYEE.COMPANY_EMPLOYEE_NOTIFY_ERROR_SUCCESS,
      COMPANY_EMPLOYEE.COMPANY_EMPLOYEE_NOTIFY_ERROR_FAIL,
      dispatch,
    );
  };

export const getScheduleOfCompanyEmployee =
  (companyEmail, employeeEmail, beginDatetime = null, endDatetime = null) =>
  (dispatch) => {
    let params = [];

    if (moment.isMoment(beginDatetime)) {
      beginDatetime.startOf("day");

      params.push(`beginDatetime=${beginDatetime.toISOString()}`);
    }

    if (moment.isMoment(endDatetime)) {
      endDatetime.endOf("day");

      params.push(`endDatetime=${endDatetime.toISOString()}`);
    }

    return ActionHelper.requestServer(
      "GET",
      `/company/${companyEmail}/employee/${employeeEmail}/schedule?${params.join(
        "&",
      )}`,
      null,
      COMPANY_EMPLOYEE.COMPANY_EMPLOYEE_GET_SCHEDULE_REQUEST,
      COMPANY_EMPLOYEE.COMPANY_EMPLOYEE_GET_SCHEDULE_SUCCESS,
      COMPANY_EMPLOYEE.COMPANY_EMPLOYEE_GET_SCHEDULE_FAIL,
      dispatch,
    );
  };



// WEBPACK FOOTER //
// ./src/actions/companyEmployeeActions.js